import { render, staticRenderFns } from "./rightApplication.vue?vue&type=template&id=b1c41aa6&scoped=true"
import script from "./rightApplication.vue?vue&type=script&lang=js"
export * from "./rightApplication.vue?vue&type=script&lang=js"
import style0 from "./rightApplication.vue?vue&type=style&index=0&id=b1c41aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c41aa6",
  null
  
)

export default component.exports